import React, { useReducer, useEffect } from 'react';
import PropTypes from 'prop-types';

import UIImage from './ui/UIImage';
import reducer from '../../../../store/componentReducer';
import { init, setValue, setValueLocalized } from '../../../../store/actions';

const initialState = {
  data: {
    type: 'MapBox',
    url: '',
    poi: [],
    image: {
      en: '',
      es: '',
      ca: '',
      pt: '',
    },
  },
};

const MapBox = ({ activeLanguage, components, handlerSetComponents, id }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const { data } = state;

  const componentIndex = components.findIndex(obj => obj.id === id);
  const { component } = components[componentIndex];

  useEffect(() => {
    if (component) init(dispatch)(component);
  }, []);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setValue(dispatch)(name, value);
  };

  const handleImage = (imageUrl) => {
    setValueLocalized(dispatch)('image', imageUrl, activeLanguage);
  };

  useEffect(() => {
    const updatedComponent = {
      id,
      component: data,
    };

    handlerSetComponents(updatedComponent, componentIndex);
  }, [data]);

  return (
    <div className="flex-1 mr-4">
      <label htmlFor="title" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
        Title
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          name="url"
          onChange={handleInput}
          type="text"
          value={data.url}
        />
      </label>
      <UIImage activeLanguage={activeLanguage} getImageUrl={handleImage} imageUrl={data.image} isFromPostal />
    </div>
  );
};

MapBox.propTypes = {
  activeLanguage: PropTypes.oneOf(['en', 'es', 'ca', 'pt']).isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};

export default MapBox;
